import { createRootRouteWithContext } from '@tanstack/react-router';

import { DashboardLayout } from '../old/layout';

export interface RouterContext {
  releaseAssortmentIA: boolean;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: DashboardLayout,
});
